import { useNavigate } from "react-router-dom";
import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap/";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useLogoutUserMutation } from '../services/appApi'

const Naviagtion = () => {
    const user = useSelector((state) => state.user)
    const [logoutUser] = useLogoutUserMutation()
    const navigate = useNavigate()
    const handleLogout = async(e) => {
        e.preventDefault()
        await logoutUser(user)
        navigate('/')


    }
    return (
        <Navbar bg="light" expand="lg">
            <Container>
                <LinkContainer to={"/"}>
                    <Navbar.Brand>
                        <i className="fa fa-comments" aria-hidden="true">
                            chatterbox
                        </i>
                    </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        {!user ? (
                            <>
                        <LinkContainer to={"/login"}>
                            <Nav.Link>Login</Nav.Link>
                        </LinkContainer>
                        <LinkContainer to={"/register"}>
                            <Nav.Link>Register</Nav.Link>
                        </LinkContainer>
                        </>
                        ) : (
                            <>
                        <LinkContainer to={"/chat"}>
                            <Nav.Link>Chat</Nav.Link>
                        </LinkContainer>
                        <NavDropdown title={
                            <>
                            <img src={user.picture} alt="profilePicture" style={{ width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover' }} />
                            {user.name}
                            </>
                        } id="basic-nav-dropdown">
                            <NavDropdown.Item href="#action/3.1">
                                Action
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.2">
                                Another action
                            </NavDropdown.Item>
                            <NavDropdown.Item href="#action/3.3">
                                Something
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action/3.4">
                                <Button variant="danger" onClick={handleLogout}>
                                    Logout
                                </Button>
                            </NavDropdown.Item>
                        </NavDropdown>
                        </>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Naviagtion;
